import React, { Fragment } from "react";

import { useActiveTenant } from "@/tenants/TenantProvider";

const TenantName = () => {
	const tenant = useActiveTenant();

	return <Fragment>{tenant?.tenantName}</Fragment>;
};

export default TenantName;
